import axios, { getEnv } from '../../../services/api';
import Axios from "axios";

export const DevolutivaPadraoService = {
    findAll: async (params, body = {}, source) => {
        try {
            const response = await axios.post(`${await getEnv('REACT_APP_URL_SERVICE')}/v1/temas/consultar`, body, {
                params,
                cancelToken: source?.token
            });
            return response.data;
        } catch (error) {
            if (Axios.isCancel(error)) {
                console.log('Requisição cancelada', error.message);
            } else {
                console.log(error.message);
                throw error;
            }
        }
    },
    
    find: async (id) => {
        try {
            const response = await axios.get(`${await getEnv('REACT_APP_URL_SERVICE')}/v1/temas/${id}`)
            return response.data;
        } catch (error) {
            return error;
        }
    },
    
    update: async (body) => {
        return await axios.put(`${await getEnv('REACT_APP_URL_SERVICE')}/v1/temas`, body);
    },
};
